export default __webpack_public_path__ + "static/media/bg_leafTint_2_lb.877b3ae4.png";